import React, {useEffect, useMemo, useRef, useState} from "react";
import {useLocation, useParams} from 'react-router-dom';
import {getCode, getLangs, getAuthStatus} from '../ApiService';
import * as postRobot from "post-robot";
import Acm from "../component/Acm";
import QuestionLeft from "../component/QuestionLeft";
import FlexLayout from "../component/FlexLayout";
import ThinkupForIframe from "../component/ThinkupForIframe";
import SideButtons from "../component/SideButtons";


function Home() {

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  const [code, updateCode] = useState([]);
  const [lang, updateLang] = useState(["python"]);
  const [preview, updatePreview] = useState("");
  const {oid} = useParams();
  const [oidLoaded, setOidLoaded] = useState(false);
  const [emSent, setEmSent] = useState(false);
  //AI助手 默认关闭
  const [aiEnabled, setAiEnabled] = useState(false);
  const [aiCollapsed, setAiCollapsed] = useState(false);
  const [oldCode, setOldCode] = useState(null);
  const [oldLang, setOldLang] = useState(null);
  const {pathname} = useLocation();
  const embedded = pathname.startsWith('/embedded') || pathname.startsWith('/yuque');

  const [sourceWindow, setSourceWindow] = useState();
  const sourceWindowRef = useRef(sourceWindow); // 创建一个 ref 来追踪最新的状态

  const [langs, setLangs] = useState(null);

  const [ready, setReady] = useState(false);

  const acmRef = useRef(null);
  const [autoRun, setAutoRun] = useState(false);
  const [initDark, setInitDark] = useState(false);

  const [customButtons, setCustomButtons] = useState(null);
  const [disableSideButtons, setDisableSideButtons] = useState(null);
  const [authInfo, setAuthInfo] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const fromVgen = queryParams.get("fromVgen");



  const handleDisableEvent = (event) => {
    event.preventDefault();
    event.stopPropagation();
    alert('此操作已被禁用');
  };

  function onEmSend(event){
    setSourceWindow(event.source)
    setAiEnabled(event.data.aiEnabled)
    setTitle(event.data.title)
    setContent(event.data.content)
    setInitDark(event.data.dark)
    setCustomButtons(event.data.customButtons)
    setDisableSideButtons(event.data.disableSideButtons)
    if (event.data.disableCopyPaste) {
      //添加全局事件监听器
      document.addEventListener('copy', handleDisableEvent, { capture: true });
      document.addEventListener('paste', handleDisableEvent, { capture: true });
      document.addEventListener('cut', handleDisableEvent, { capture: true });
    }

    console.log("嵌入式数据接收: ",event.data)

    if (Array.isArray(event.data.code)) {
      updateCode(event.data.code);
      setOldCode(event.data.code)
      localStorage.setItem("code_"+event.data.lang, JSON.stringify(event.data.code));
    }else{
      updateCode([event.data.code])
      setOldCode([event.data.code])
      localStorage.setItem("code_"+event.data.lang, JSON.stringify([event.data.code]));
    }

    if (event.data.lang === 'html'){
      updateLang(['html','css','javascript']);
    }else if (Array.isArray(event.data.lang)) {
      updateLang(event.data.lang)
    }else{
      updateLang([event.data.lang])
    }
    setOldLang(event.data.lang)

    window.nameSpace = event.data.nameSpace;
    window.podName = event.data.podName;
    window.container = event.data.container;
    window.workspace = event.data.workspace;

    if (event.data.run && event.data.lang !== "html"){
      setAutoRun(true)
    }
    setEmSent(true)
  }

  const checkAuth = (token) =>{
    getAuthStatus(token).then((res) => {
      console.log(res, 'window.opener')
      setAuthInfo(res.data)
    }).catch((error) => {
      // if (error.status === 401){
      //   window.location.href = process.env.REACT_APP_CLOUD_LAB_URL + "/login/callback?redirect=" + encodeURIComponent(window.location.href);
      // }
      setAuthInfo(error.response.data)
    })
  }

  useEffect(() => {
    checkAuth()

    // 向父级窗口或者opener获取token
    window.addEventListener('load', async () => {
      if (window.opener) {
        try {
          const res = await postRobot.send(window.opener, 'getToken')
          const { token } = res?.data || {};
          if (token) {
            checkAuth(token)
          }
        } catch (error) {
          console.log(error, 'window.opener')
        }
      }
      if (window.parent && window.parent !== window) {
        try {
          const res = await postRobot.send(window.parent, 'getToken')
          const { token } = res?.data || {};
          if (token) {
            checkAuth(token)
          }
        } catch (error) {
          console.log(error, 'window.parent')
        }
      }
    });
    
    //新的嵌入式rpc风格listener注册(可返回数据)
    postRobot.on('send', onEmSend);
    //刷新回调
    window.addEventListener('beforeunload', () => {
      if(sourceWindowRef.current){
        postRobot.send(sourceWindowRef.current, 'refresh');
      }
    });

    if (!embedded){
      setAiEnabled(true);
      //获取支持语言列表
      getLangs().then(langs => {
        console.log("langs",langs)
        setLangs(langs)
      })
    }

    if (oid){
      getCode(oid).then(codePiece => {
        //本地缓存key
        const langKey = oid + "_" + codePiece.lang;

        if (codePiece.code.startsWith('["')) {
          let codeJSON = JSON.parse(codePiece.code);
          updateCode(codeJSON)
          setOldCode(codeJSON)
          localStorage.setItem(langKey, JSON.stringify(codeJSON));
        }else{
          updateCode([codePiece.code])
          setOldCode([codePiece.code])
          localStorage.setItem(langKey, JSON.stringify([codePiece.code]));
        }
        if (codePiece.lang === 'html'){
          updateLang(['html','css','javascript']);
        }else {
          updateLang([codePiece.lang])
        }
        setOldLang(codePiece.lang)
        setOidLoaded(true)
      })
    }
    if (!oid && !embedded && localStorage.getItem("lang")){
      updateLang(JSON.parse(localStorage.getItem("lang")))
    }

  }, []);

  useEffect(() => {
    sourceWindowRef.current = sourceWindow; // 在状态更新时更新 ref
  }, [sourceWindow]);

  useEffect(() => {
    let ready = checkReady();
    setReady(ready)
  }, [langs, oidLoaded, emSent, authInfo]);

  useEffect(() => {
    if (!oid && !embedded){
      localStorage.setItem("lang", JSON.stringify(lang))
    }
  }, [lang]);

  const checkReady = () => {
    if (! authInfo) {
      return false;
    }
    //非嵌入模式必须加载完langs
    if (! embedded){
      if (! langs){
        return false;
      }
    }
    //oid模式必须加载完code
    if (oid){
      if (! oidLoaded){
        return false;
      }
    }
    //嵌入模式并且无oid 必须发送过一次数据
    if (embedded && !oid && !emSent){
      return false;
    }
    return true;
  }

  const handleCollapse = () => {
    console.log("collapsed in runner Home")
    setAiCollapsed(true)
  }

  const showAI = useMemo(() => {
    return aiEnabled && authInfo?.isLogin

  }, [aiEnabled, authInfo]);

  return (
    <>
      { ready && (
        //标题和内容不为空表示acm模式, 左侧显示问题内容
        <FlexLayout  ratio={(showAI && !aiCollapsed)?"66.7%":"100%"}>
          {(title && content)?(
            <FlexLayout  ratio="33.3%">
              <QuestionLeft title={title} content={content}/>
              <Acm
                lang={lang}
                code={code}
                updateCode={updateCode}
                updateLang={updateLang}
                preview={preview}
                updatePreview={updatePreview}
                embedded={true}
                sourceWindow={sourceWindow}
                aiEnabled={aiEnabled}
                oldCode={oldCode}
                oldLang={oldLang}
                ref={acmRef}
                langs={langs}
                autoRun={autoRun}
                initDark={initDark}
                customButtons={customButtons}
                platform={embedded ? "oscollege" : ""}
                setAiCollapsed={setAiCollapsed}
                authInfo={authInfo}
              />
            </FlexLayout>
          ):(
          <Acm
            lang={lang}
            code={code}
            embedded={embedded}
            updateCode={updateCode}
            updateLang={updateLang}
            preview={preview}
            updatePreview={updatePreview}
            sourceWindow={sourceWindow}
            aiEnabled={aiEnabled}
            oid={oid}
            oldCode={oldCode}
            setOldCode={setOldCode}
            oldLang={oldLang}
            ref={acmRef}
            langs={langs}
            autoRun={autoRun}
            initDark={initDark}
            customButtons={customButtons}
            platform={embedded ? "oscollege" : ""}
            setAiCollapsed={setAiCollapsed}
            authInfo={authInfo}
          />
          )}
          {
            showAI ? <ThinkupForIframe linkToken={authInfo.token} handleCollapse={handleCollapse}/>:<div></div>
          }

        </FlexLayout>
      )}
      {(fromVgen || disableSideButtons) ? <></> : <SideButtons showAI={showAI} aiCollapsed={aiCollapsed} setAiCollapsed={setAiCollapsed} authInfo={authInfo} lang={lang} code={code} preview={preview}/>}
    </>
  );
}

export default Home;
